import { render, staticRenderFns } from "./FileUrl.vue?vue&type=template&id=a8f6a8de&scoped=true&"
import script from "./FileUrl.vue?vue&type=script&lang=js&"
export * from "./FileUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f6a8de",
  null
  
)

export default component.exports